<template>
  <div>
    <van-swipe :autoplay="3000" style="height: 150px; margin: 0 10px; border-radius: 8px">
      <van-swipe-item v-for="(image, index) in carouselList" :key="index">
        <a @click="nav(image.linkPath)">
          <img v-lazy="$baseurl + image.picPath" style="width: 100%" />
        </a>
      </van-swipe-item>
    </van-swipe>
    <!-- <ul  v-if="data.type=='2'">
        <li v-for="(image,index) in data.imagelist" :key="index" class="cap-image-ad__content" :style="'margin:'+data.imagegap+'px 0px;'">
            <div class="image-wrapper">
                <a :href="image.url">
                    <img alt="" class="cap-image-ad__image" v-lazy="image.src+''" />
                </a>
            </div>
        </li>
    </ul>

    <div v-if="data.type=='3'||data.type=='4'||data.type=='5'" class='cap-image-ad__image-nav' style='overflow-x:scroll;' >
        <div v-for="(item,index) in data.imagelist" :key="index" class="image-wrapper" :style="'width:'+(data.type=='3'?'80':(data.type=='4'?'40':'20'))+'%;margin-right:'+data.imagegap+'px;'">
            <a :href="item.link" class="cap-image-ad__link cap-image-ad__link--image-nav" >
                <div class="cap-image-ad__image">
                    <img :src="item.src+'?w=640'" style="width: 100%; " />
                </div>
            </a>
        </div>
    </div> -->
  </div>
</template>

<script>
import appconst from "../../config/appconst";
export default {
  name: "imageAd",
  components: {},
  props: {
    data: Object,
    carouselList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    carouselList: {
      handler: function (val, oldval) {
        if (val != oldval) {
          this.$nextTick(() => {
            this.init();
          });
        }
      },
      immediate: true, //关键
      deep: true,
    },
  },
  data() {
    return {
      height: 0,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.carouselList.length == 0) {
        return;
      }
      console.log("数据", this.carouselList);
      var image = this.carouselList[0];
      let img = new Image();
      img.src = this.$baseurl + image.picPath;
      var width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      img.onload = () => {
        this.height = Math.ceil((img.height / img.width) * width);
        console.log("高度打印:", this.height);
      };
    },
    nav(path) {
      if (path) {
        this.$router.push({
          path: path,
        });
      }
    },
  },
};
</script>

<style></style>
